// extracted by mini-css-extract-plugin
export var errorIcon = "_jh-1";
export var nameLogo = "_jh-0";